import { SVGProps } from 'react'

export const Vector = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.67969 6.95442L7.93692 13.4999L17.3228 1.49988" stroke="#FF7365" strokeWidth="2" />
    </svg>
  )
}
